"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { isPrimaryNavActive, PRIMARY_NAV_ITEMS } from "@/lib/navigation";

export default function BottomTabBar() {
  const pathname = usePathname();
  if (pathname === "/login") return null;

  return (
    <nav aria-label="移动端主导航" className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur sm:hidden">
      <div className="mx-auto flex h-[var(--mobile-tab-height)] max-w-md items-stretch">
        {PRIMARY_NAV_ITEMS.map((tab) => {
          const Icon = tab.icon;
          const active = isPrimaryNavActive(pathname, tab);
          return (
            <Link
              key={tab.href}
              href={tab.href}
              aria-current={active ? "page" : undefined}
              className={cn(
                "relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] transition-colors",
                active ? "text-primary" : "text-muted-foreground hover:text-foreground"
              )}
            >
              {active && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-primary" />}
              <Icon className="h-[22px] w-[22px]" />
              <span className="font-medium">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
